<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>local_shipping</mat-icon></div>
          <mat-card-title>
            Fornecedor
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-12 col-md-1">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>ID</mat-label>
                  <input formControlName="id" matInput readonly>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Nome Fantasia</mat-label>
                  <input formControlName="nomeFantasia" matInput placeholder="Digite seu nome"
                    minlength="3" maxlength="250" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Razão Social</mat-label>
                  <input formControlName="razaoSocial" matInput placeholder="Digite seu nome"
                    minlength="3" maxlength="250" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Telefone</mat-label>
                  <input formControlName="telephone" matInput placeholder="(99)9999-9999"
                    mask="(00) 0 0000-0000 || (00) 0000-0000" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>CEP</mat-label>
                  <input id="cep" name="cep" formControlName="cep" mask="00000-000" matInput
                    (blur)="buscarDadosCep()" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Estado</mat-label>
                  <mat-select id="estado" name="estado" formControlName="estado" required
                    (selectionChange)="onEstadoChange($event.value)">
                    <mat-option [value]="estado" *ngFor="let estado of estados">{{ getSiglaEstado(estado) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Endereço</mat-label>
                  <input formControlName="address" matInput placeholder="Digite seu endereço" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Quadra</mat-label>
                  <input formControlName="block" matInput placeholder="Digite sua quadra" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Lote</mat-label>
                  <input formControlName="batch" matInput placeholder="Digite seu lote" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Complemento</mat-label>
                  <input formControlName="complement" matInput placeholder="Complemento">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Bairro</mat-label>
                  <input id="bairro" name="bairro" matInput formControlName="bairro" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field appearance="fill" class="w-100" *ngIf="cidades.length; else cidadeTexto">
                  <mat-label>Cidade</mat-label>
                  <mat-select id="cidade" name="cidade" formControlName="cidade">
                    <mat-option [value]="cidade" *ngFor="let cidade of cidades">{{ cidade }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-template #cidadeTexto>
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Cidade</mat-label>
                    <input id="cidade" name="cidade" formControlName="cidade" matInput>
                  </mat-form-field>
                </ng-template>
              </div>
              <div class="col-12 col-md-12">
                <mat-form-field class="full-width" appearance="fill" class="w-100">
                  <mat-label>Observação</mat-label>
                  <textarea formControlName="observation" matInput placeholder="Observação"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" mat-stroked-button (click)="limparFormulario()">
                <mat-icon>insert_drive_file</mat-icon> Limpar
              </button>
              <button [disabled]="!formulario.valid" mat-raised-button color="primary" type="submit">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
          <div class="esp-top">
            <div *ngIf="formulario.controls.razaoSocial.errors && !formulario.controls.razaoSocial.pristine"
              class="alert alert-warning" role="alert">
              Campo nome deve conter entre 3 e 250 caracteres!
            </div>
          </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
